(function($) {
	'use strict';

	/**
	 * Add Margin Top to Dropdown Menus.
	 * 
	 * We don't need to wait on scroll to apply the margin-top
	 * to the dropdown menus. Let's add them out of the gate.
	 */
	 $( document ).ready( function() {

	});

	/**
	 * Fade Single Blog Hero Image on Scroll.
	 */
	$(window).scroll(function () {
		var scrollTop 	= $(window).scrollTop();
		var height 		= $(window).height();
	
		$('.single-post .thumbnail-wrapper .single-post-hero').css({
			'opacity': ((height - scrollTop) / height),
			'transform': 'scale(' + (height + scrollTop) / height + ')'
		});
		
	});

})( jQuery );